<template>
  <div>

    <br />
    <router-link :to="{ name: 'AvicoursePage' }">
      Retour à la page de l'Avicourse
    </router-link>

    <div v-html="html"></div>

    <template v-if="html === null">
      <h3>Page non trouvée</h3>
    </template>

    <!--<router-link :to="{ name: 'AvicoursePage' }">
      Retour à la page de l'Avicourse
    </router-link>-->
    <br /><br />

  </div>
</template>

<script>
  import _ from 'lodash';

  export default {
    name: 'AvicourseSingle',
    data() {
      return {
        year: this.$route.params.year,
        html: null
      };
    },
    async mounted() {
      const data = await fetch(this.path());
      this.html = await data.text();
    },
    methods: {
      path() {
        this.year = ~~this.year;
        if (!_.isNumber(this.year)) {
          this.year = 2019;
        }
        return '/pages/avicourse/' + this.year + '.html';
      }
    }
  };
</script>

<style scoped>
#table_listes {
    margin-left: 10px;
}

#table_listes td {
    vertical-align: middle;
    padding-bottom: 5px;
}

#titre_entete {
    float: left;
    width: 70%;
}

#colonne_texte {
    float: left;
    width: 70%;
}

#colonne_texte p, #resultats p, #especes_observees p {
    margin-bottom: .5em; /*1.4em*/
    line-height: 1.5em; /*1.5em*/
}

#resultats, #especes_observees {
    margin: auto; /*permet de centrer la tableau dans la page */
}

#colonne_photos {
    margin-left: 67%;
    margin-top: 65px;
}

#colonne_texte p {
    margin-bottom: .5em; /*1.4em*/
    line-height: 1.5em; /*1.5em*/
}

.caption_petites_photos {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 10px;
}

/***Style the unordered list with the class 'enlarge'***/
ul.enlarge {
    list-style-type: none; /*remove the bullet point*/
}

ul.enlarge li {
    display: inline-block; /*places the images in a line*/
    position: relative; /*allows precise positioning of the popup image when used with position:absolute - see support section */
    z-index: 0; /*resets the stack order of the list items - we'll increase in step 4. See support section for more info*/
    margin: 10px 40px 0 20px; /*space between the images*/
}

/***In the HTML in step one we placed the large image inside a 'span' tag, now we move it off the page until it's required***/
ul.enlarge span {
    position: absolute; /*see support section for more info on positioning*/
    left: -9999px; /*moves the span off the page, effectively hidding it from view*/
}

/***Note: This styling will apply to both the thumbnail and popup image, unless you override these styles in step five***/
ul.enlarge img {
    /*give the thumbnails a frame*/
    background-color: #eae9d4; /*frame colour*/
    padding: 6px; /*frame size*/
    /*add a drop shadow to the frame*/
    -webkit-box-shadow: 0 0 6px rgba(132, 132, 132, .75);
    -moz-box-shadow: 0 0 6px rgba(132, 132, 132, .75);
    box-shadow: 0 0 6px rgba(132, 132, 132, .75);
    /*and give the corners a small curve*/
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
}

ul.enlarge li:hover {
    z-index: 50; /*places the popups infront of the thumbnails, which we gave a z-index of 0 in step 1*/
    cursor: pointer; /*changes the cursor to a hand*/
}

/***We bring the large image back onto the page by reducing left from -9999px (set in step 2) to figures below***/
ul.enlarge li:hover span { /*positions the 'span' tag when the 'li' tag (which contains the thumbnail) is hovered*/
    top: -200px; /*the distance from the bottom of the thumbnail to the top of the popup image*/
    left: -700px; /*distance from the left of the thumbnail to the left of the popup image*/
}

/***To make it look neater we used :nth-child to set a different left distance for each image***/
/*        ul.enlarge li:hover:nth-child(2) span {
            left: -100px;
        }

        ul.enlarge li:hover:nth-child(3) span {
            left: -200px;
        }
*/
/***Override the styling of images set in step 3 to make the frame smaller and the background darker***/
ul.enlarge span img {
    padding: 2px; /*size of the frame*/
    background: #ccc; /*colour of the frame*/
}

/***Style the 'span' tag containing the framed images and the caption***/
ul.enlarge span {
    /**Style the frame**/
    padding: 10px; /*size of the frame*/
    background: #eae9d4; /*colour of the frame*/
    /*add a drop shadow to the frame*/
    -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, .75));
    -moz-box-shadow: 0 0 20px rgba(0, 0, 0, .75);
    box-shadow: 0 0 20px rgba(0, 0, 0, .75);
    /*give the corners a curve*/
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
    /**Style the caption**/
    font-family: Verdana, Arial, Helvetica, sans-serif;
    font-size: 1.5em;
    text-align: center;
    color: #b1661b; /*#495a62*/
}
</style>
